import { textStyles, colors, loadingDark, loadingLight } from '../../shared/styles';

export const styles = {
  title: {
    color: colors.darkType,
    fontFamily: 'ProximaNovaBold',
    fontSize: '25px',
    letterSpacing: '-0.11px',
    lineHeight: '25px',
    position: 'relative',
    margin: 0,
    paddingBottom: '5px'
  },
  detailRow: {
    position: 'relative',
    minHeight: 20,
    ...textStyles.body1Grey,
  },
  dateContainer: {
    display: 'inline-block',
    marginRight: 20,
    paddingRight: 20,
    borderRight: '1px solid '+ colors.greyLine,
  },
  locationCell: {
    ...textStyles.body1Grey,
  },

  descContainer: (isMobile = false) => ({
    position: 'relative',
    paddingBottom: isMobile ? 10 : 42,
    paddingTop: isMobile ? 20 : 42,
    borderBottom: isMobile ? 'none' : '1px solid '+ colors.greyLine,
  }),
  link: {
    ...textStyles.textLink2Blue,
    textAlign:'center',
    fontSize: 14,
  },

  loadingTitle: (show) => ({
    position: 'absolute',
    top: 7,
    left: 0,
    zIndex: 2,
    width: '80%',
    height: 34,
    pointerEvents: 'none',
    ...loadingDark,
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  loadingDetails: (show) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    width: '50%',
    height: 20,
    pointerEvents: 'none',
    ...loadingLight,
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  moreButtonWrap: {
    marginTop: '8px',
    marginBottom: '-8px',
    position: 'relative'
  },
  moreImg: {
    marginLeft: 5,
    width: 10,
    height: 10
  }
};



/** WEBPACK FOOTER **
 ** ./components/eventSummary/styles.js
 **/